export const ptBr = {
  translation: {
    floatingButton: {
      suggestion: "sugestão",
      suggestions: "sugestões",
      notification: {
        close: "Fechar",
        draggable: "Arrastar",
      },
    },
    sidebar: {
      header: {
        title: "BIA Agents",
        salesTitle: "Sugestões de vendas",
      },
      tabs: {
        chat: "Chat",
        historico: "Histórico",
        sales: "Sales Agents",
      },
      suggestions: {
        title: "Sugestões com base no pedido",
        description: "Quem compra os itens no seu pedido também costuma comprar:",
        loading: "Carregando sugestões...",
        empty: "Nenhuma sugestão disponível",
        code: "Código",
        addButton: "Adicionar",
        price: "R$",
      },
      repeatOrder: {
        title: "Repetir Compra",
        empty: "Nenhum pedido encontrado",
        lastPurchase: "Última compra do cliente em",
        order: "O pedido",
        orderItems: "possui os seguintes itens:",
        selectAll: "Selecionar todos",
        totalOrder: "Total do pedido:",
        repeatButton: "Repetir compra",
        itemQuantity: "un. |",
        each: "cada",
      },
      chat: {
        placeholder: "💬 Chat content will be displayed here",
      },
      history: {
        placeholder: "📋 Order history will be displayed here",
      },
      close: "Fechar",
    },
    errors: {
      loadSuggestions: "Erro ao carregar sugestões:",
      invalidMovementType: "Tipo de movimento não é permitido para sugestões:",
      paramsBuildCarrinhoNotInitialized: "paramsBuildCarrinho is not initialized for CART context",
      floatingButtonPosition: "Erro ao carregar posição do botão flutuante:",
      floatingButtonSavePosition: "Erro ao salvar posição do botão flutuante:",
    },
    logs: {
      suggestionsLoaded: "sugestões carregadas da API",
    },
  },
};
